import React from "react";
import { Alert as NAlert, IAlertProps } from "native-base";

export const Alert: React.FC<IAlertProps> = (props) => {
  return <NAlert {...props} />;
};

export default Alert;
